import React, { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import clsx from "clsx";
import Scrollbars from "react-custom-scrollbars";
import Icon from "@mdi/react";
import { Avatar, IconButton } from "@material-ui/core";
import { mdiMenuDown, mdiClose } from "@mdi/js";
import useBodyLogic from "./useBodyLogic";
import useCacheDataMainTask from "hooks/useCacheDataMainTask";
import MemberSetting from "views/ProjectPage/Modals/MembersSetting";
import DetailEmotionModal from "./DetailEmotionModal";
import DetailViewedModal from "./DetailViewedModal";
import Message from "./Message";
import "./styles.scss";
import eventDispatcher from "views/JobDetailPage/utils/eventDispatcher";
import { EVENT } from "views/JobDetailPage/utils/constants";

const BodyPart = (props) => {
  const { t } = useTranslation();
  const chats = useCacheDataMainTask("chat.chats", { data: [] });
  const detailTask = useCacheDataMainTask(
    "taskDetail.detailTask.taskDetails",
    {}
  );
  const { clickToBottom } = props;
  const {
    isMore,
    isLoading,
    isShowBackChat,
    searchChatKey,
    isSending,
    isShowSendStatus,
    viewedChatMembers,
    focusId,
    focusTopId,
  } = useCacheDataMainTask("chat", {
    isMore: false,
    isLoading: false,
    isShowBackChat: false,
    searchChatKey: "",
    isSending: false,
    isShowSendStatus: false,
    viewedChatMembers: [],
    focusId: null,
    focusTopId: null,
  });

  const {
    chatRef,
    chatRefScroll,
    viewPermissions,
    project,
    isMyLastChat,
    isShowScroll,
    openViewedModal,
    chatEmotion,
    openDetailEmotionModal,
    showMembers,
    showedChats,
    openAddModal,
    plusMember,
    last_id,
    date_create,
    name,
    start_date,
    end_date,
    user_create,
    setOpenAddModal,
    setOpenDetailEmotionModal,
    setOpenViewedModal,
    onClickCreateMember,
    onClickScrollToBottom,
    onClickBack,
    handleReplyChat,
    handleForwardChat,
    handleDetailEmotion,
    onClickDetailViewed,
    handleScrollFrame,
    onScrollStop,
  } = useBodyLogic({
    chats,
    detailTask,
    setSelectedChat: props.setSelectedChat,
    isMore,
    isLoading,
    isShowBackChat,
    searchChatKey,
    isSending,
    isShowSendStatus,
    viewedChatMembers,
    focusId,
    focusTopId,
  });

  const [tagTaskFilter, setTagTaskFilter] = useState(null);

  useEffect(() => {
    onClickScrollToBottom();
  }, [clickToBottom]);

  useEffect(() => {
    return eventDispatcher.listen(
      EVENT.CHANGE_TAG_TASK_FILTER_CHAT,
      (event, payload) => {
        setTagTaskFilter(payload);
      }
    );
  }, []);

  return (
    <div className={clsx("bodyChat", { bodyChat__reply: props.isReply })}>
      <Scrollbars
        autoHide
        autoHideTimeout={500}
        ref={chatRef}
        onScrollFrame={handleScrollFrame}
        onScrollStop={onScrollStop}
        renderView={(props) => (
          <div
            {...props}
            ref={chatRefScroll}
            className="bodyChat--scrollWrap"
          />
        )}
      >
        <div className="bodyChat--scroll">
          {!last_id && !searchChatKey && !tagTaskFilter && (
            <React.Fragment>
              <div className="wrap-time">
                <div className="time">{date_create}</div>
              </div>
              <div className="wrap-common-row">
                <div className="bodyChat--project">
                  <Avatar
                    alt="creator"
                    src={user_create.avatar}
                    className="bodyChat--projectAvatar"
                  />
                  <div className="bodyChat--notifyName">
                    {t("LABEL_CHAT_TASK_DA_TAO_BANG_MOI", {
                      name: user_create.name || "",
                    })}
                  </div>
                  <div className="bodyChat--projectName">{name}</div>
                  {start_date && end_date && (
                    <div className="bodyChat--projectProgress">
                      {t("LABEL_CHAT_TASK_TIEN_DO_FROM_TO", {
                        start_date,
                        end_date,
                      })}
                    </div>
                  )}
                  <button
                    onClick={onClickCreateMember}
                    className="bodyChat--buttonAddMember"
                  >
                    {t("LABEL_CHAT_TASK_THEM_THANH_VIEN")}
                  </button>
                </div>
              </div>
              <div className="bodyChat--introRow">
                <div className="bodyChat--introImages">
                  <div className="bodyChat--introItem bodyChat--introItem__left">
                    <img alt="intro" src="/images/intro/intro-bg-2.png" />
                    <div className="bodyChat--introTitle">
                      {t("LABEL_CHAT_TASK_THAO_LUAN")}
                    </div>
                  </div>
                  <div className="bodyChat--introItem">
                    <img alt="intro" src="/images/intro/intro-bg-3.png" />
                    <div className="bodyChat--introTitle">
                      {t("LABEL_CHAT_TASK_QUAN_LY")}
                    </div>
                  </div>
                  <div className="bodyChat--introItem bodyChat--introItem__right">
                    <img alt="intro" src="/images/intro/intro-bg-4.png" />
                    <div className="bodyChat--introTitle">
                      {t("LABEL_CHAT_TASK_CHIA_SE")}
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          {isLoading && isMore && (
            <div className="bodyChat--loader" key={0}>
              {t("LABEL_CHAT_TASK_DANG_TAI")}
            </div>
          )}
          {showedChats.length === 0 && (searchChatKey || tagTaskFilter) && (
            <div className="bodyChat--searchEmpty">
              <img src="/images/ic_not_found.png" alt="no result" />
              <br />
              {t("LABEL_CHAT_TASK_KHONG_TIM_THAY_KET_QUA")}
            </div>
          )}
          {showedChats.map((el, id) => (
            <Message
              {...el}
              key={id}
              handleForwardChat={handleForwardChat(el)}
              handleDetailEmotion={handleDetailEmotion(el)}
              handleReplyChat={handleReplyChat(el)}
              onClickCreateMember={onClickCreateMember}
            />
          ))}
          <div id="chatStatusDiv" className="bodyChat--chatStatus">
            {viewedChatMembers.length > 0 && (
              <div className="bodyChat--viewed" onClick={onClickDetailViewed}>
                {t("LABEL_CHAT_TASK_DA_XEM")}
                {showMembers.map(({ avatar, name }, i) => (
                  <abbr title={name} key={i}>
                    <Avatar className="bodyChat--viewedAvatar" src={avatar} />
                  </abbr>
                ))}
                {plusMember > 0 && (
                  <Avatar className="bodyChat--viewedAvatar">{`+${plusMember}`}</Avatar>
                )}
              </div>
            )}
            {isShowSendStatus && isMyLastChat && (
              <div className="bodyChat--sending">
                {isSending
                  ? t("LABEL_CHAT_TASK_DANG_GUI")
                  : t("LABEL_CHAT_TASK_DA_GUI")}
              </div>
            )}
          </div>
        </div>
      </Scrollbars>
      {isShowScroll && (
        <IconButton
          className="bodyChat--buttonToBot"
          onClick={onClickScrollToBottom}
        >
          <Icon path={mdiMenuDown} size={1.5} />
        </IconButton>
      )}
      {isShowBackChat && (
        <IconButton
          className="bodyChat--buttonToBot bodyChat--buttonBack"
          onClick={onClickBack}
        >
          <Icon path={mdiClose} size={1.5} />
        </IconButton>
      )}

      {openAddModal && (
        <MemberSetting
          open={openAddModal}
          setOpen={setOpenAddModal}
          canEdit={get(
            viewPermissions.permissions,
            [project.id, "update_project"],
            false
          )}
          project_id={project.id}
          project={project}
        />
      )}
      <DetailEmotionModal
        isOpen={openDetailEmotionModal}
        setOpen={setOpenDetailEmotionModal}
        data_emotion={chatEmotion}
      />
      <DetailViewedModal
        isOpen={openViewedModal}
        setOpen={setOpenViewedModal}
      />
    </div>
  );
};
export default memo(BodyPart);
